import { EditableTableCell } from 'components/EditableTableCell';
import type { ActKc2StatusEnum } from 'gql/graphql';

import type React from 'react';
import { memo } from 'react';

import { useRequestsKC2CostEdit } from './useRequestsKC2CostEdit';

interface IWorkOrderPriceKC2CostEditProps {
    actKC2Id: number;
    workOrderPriceId: number;
    defaultValue: string;
    actKC2Status: ActKc2StatusEnum;
    onChange: (reloadRowsIds?: number[] | null) => void;
    disabled?: boolean;
    style?: React.CSSProperties;
    decimalScale: number;
}

export const WorkOrderPriceKC2CostEdit = memo(
    ({
        actKC2Id,
        workOrderPriceId,
        defaultValue,
        actKC2Status,
        disabled,
        onChange,
        style,
        decimalScale,
    }: IWorkOrderPriceKC2CostEditProps) => {
        const { handleOnChange, getRequestData, getRequestError, getRequestStatus } = useRequestsKC2CostEdit(
            actKC2Id,
            workOrderPriceId,
            defaultValue,
            actKC2Status,
        );

        return (
            <EditableTableCell
                decimalScale={decimalScale}
                disabled={disabled}
                fieldValue={defaultValue}
                reloadHandler={onChange}
                updateRequest={handleOnChange}
                updateStatus={getRequestStatus}
                requestResultObj={getRequestData}
                requestErrors={getRequestError}
                errorModalTitle="Редактирование Стоимости"
                inputStyles={style}
            />
        );
    },
);

WorkOrderPriceKC2CostEdit.displayName = 'WorkOrderPriceKC2CostEdit';
